import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { BusinessForwardSearchItem } from 'components/business';
import { ConsultingCategory } from 'base/api';
import ReactPaginate from 'react-paginate';
import { ShowIf, NoContent } from 'components/utils';
import _ from 'lodash';

class BusinessForwardAdvisorySearchList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      businesses: [],
      selectedCategoryId: '',
      isSearched: false,
      consultingCategories: [],
      isLoading: false
    }

    this.handleChoose = this.handleChoose.bind(this);
    this.setDefaultBusiness = this.setDefaultBusiness.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.postLoadBusinesses = this.postLoadBusinesses.bind(this);
    this.loadBusinessesFromServer = this.loadBusinessesFromServer.bind(this);
    this.postLoadConsultingCategories = this.postLoadConsultingCategories.bind(this);
    this.loadConsultingCategoriesFromServer = this.loadConsultingCategoriesFromServer.bind(this);
  }

  static propTypes = {
    onChoose: PropTypes.func.isRequired
  }

  componentDidMount() {
    this.props.dispatch({
      type: 'UPDATE_BUSINESSES_LIST',
      businesses: []
    });
    this.loadConsultingCategoriesFromServer();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.listBusinesses != this.state.listBusinesses) {
      this.setState({isLoading: true}, () => {
        this.setState({
          businesses: nextProps.listBusinesses
        }, () => {
          this.setState({isLoading: false});
        });
      })
    }
    if (nextProps.listConsultingCategories != this.state.listConsultingCategories) {
      this.setState({
        consultingCategories: nextProps.listConsultingCategories
      });
    }
  }

  setDefaultBusiness() {
    this.setState({
      businesses: [],
      selectedCategoryId: '',
      isSearched: false
    });
  }

  handleSelect(e) {
    let value = e.target.value;

    if (!value) {
      this.setDefaultBusiness();
      return this.props.dispatch({
        type: 'UPDATE_BUSINESSES_LIST',
        businesses: []
      });
    }

    this.setState({
      isLoading: true
    }, () => {
      this.setState({
        selectedCategoryId: value,
        isSearched: true
      });
      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(() => {
        this.loadBusinessesFromServer();
      }, 1000);
    });

  }

  loadBusinessesFromServer() {
    ConsultingCategory.actions.getBusinesses.request({
      id: this.state.selectedCategoryId
    }).then(res => {
      this.postLoadBusinesses(res.data);
    });
  }

  postLoadBusinesses =(data) => {
    if (!data) {
      return;
    }

    this.props.dispatch({
      type: 'UPDATE_BUSINESSES_LIST',
      businesses: data
    });
  }

  loadConsultingCategoriesFromServer() {
    ConsultingCategory.actions.list.request().then(res => {
      this.postLoadConsultingCategories(res.data);
    });
  }

  postLoadConsultingCategories =(data) => {
    if (!data) {
      return;
    }

    this.props.dispatch({
      type: 'UPDATE_CONSULTING_CATEGORIES_LIST',
      categories: data
    });
  }

  handleChoose = (id) => {
    const business = _.find(this.state.businesses, item => item.id === id);
    if (!id || !business) {
      return;
    }

    let businessResult = {
      ...{},
      id: id,
      logo: business.logo,
      name: business.name,
      phone: business.phone,
      email: business.email,
    };

    this.props.onChoose && this.props.onChoose(businessResult);
  }

  render() {
    const { isLoading, isSearched, businesses, selectedCategoryId, total, consultingCategories } = this.state;
    return (
      <div className="content">
        <div className="form-group">
          <label>Lọc doanh nghiệp theo lĩnh vực</label>
          <select className="form-control" name="catogory" onChange={this.handleSelect.bind(this)} value={selectedCategoryId}>
            <option value="">Chọn lĩnh vực tư vấn</option>
            {consultingCategories && consultingCategories.map((category, i) => (
              <option value={category.id}>{category.name}</option>
            ))}
          </select>
        </div>
        <ShowIf condition={isLoading || (businesses && businesses.length === 0)}>
          <NoContent
            content={
              isLoading ? 'Đang tải dữ liệu...' : (
                isSearched ? 'Không có kết quả nào' : 'Hãy chọn lĩnh vực tư vấn'
              )
            }
            height={300}
          />
        </ShowIf>
        <ShowIf condition={!isLoading && businesses && businesses.length > 0}>
          <table className="table table-striped businesses-forward-table">
            <thead className="thead">
              <tr className="tr-head">
                <th scope="col" className="col-lg-1">
                  #
                </th>
                <th scope="col" className="col-lg-8">
                  Doanh nghiệp
                </th>
                <th scope="col" className="col-lg-3 text-center">
                  Hành động
                </th>
              </tr>
            </thead>
            <tbody className="tbody">
              {businesses.map((business, i) => (
                <BusinessForwardSearchItem
                  key={i}
                  data={business}
                  index={i + 1}
                  onChoose={this.handleChoose}
                  isCanNotChoose={_.indexOf(this.props.disabledIdList, business.id) !== -1}/>
              ))}
            </tbody>
          </table>
        </ShowIf>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  listBusinesses: state.listBusinesses,
  listConsultingCategories: state.listConsultingCategories
});

export default connect(mapStateToProps)(BusinessForwardAdvisorySearchList);


// WEBPACK FOOTER //
// ./components/business/BusinessForwardAdvisorySearchList.jsx